module.exports = __webpack_public_path__ + "media/images/badge-c2d4916f4c7ce132e847afe43fef0b92.svg";